import React from 'react';
import { DateSelect } from '@shared/UI';
import { useBmoTransactionsTable } from '../../lib';
import './BmoTransactionsTableFilters.scss';
import { SearchInput } from '@features/SearchInput';
import { formats } from '@shared/utils';

export const BmoTransactionsTableFilters: React.FC = () => {
    const { date, setDate, setSearchString } = useBmoTransactionsTable();

    return (
        <div className='widget-bmo-transactions-table-filters'>
            <DateSelect
                currentValue={date}
                placeholder='Select Date'
                dropdownPlacement='bottom-left'
                format={formats.dateWithYear}
                onDateSelect={(date) => date && setDate(date)}
            />
            <SearchInput
                setValue={setSearchString}
                placeholder='Amount'
            />
        </div>
    );
};
